"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var context_utils_exports = {};
__export(context_utils_exports, {
  consoleLogger: () => consoleLogger,
  isThenable: () => isThenable,
  noParamsLogger: () => noParamsLogger,
  nullPromise: () => nullPromise,
  platformNow: () => platformNow,
  platformNowDiff: () => platformNowDiff,
  reportTelemetryFailure: () => reportTelemetryFailure
});
module.exports = __toCommonJS(context_utils_exports);
const errorPrinter = /* @__PURE__ */ __name(({ message, stack, ...rest }) => ({
  message,
  stack,
  ...rest
}), "errorPrinter");
function replacer(value) {
  return value instanceof Error ? errorPrinter(value) : value;
}
__name(replacer, "replacer");
const consoleLogger = /* @__PURE__ */ __name((logParams) => ({
  info: /* @__PURE__ */ __name((msg, args) => {
    console.info(
      msg,
      ...Object.entries({ ...args ?? {}, ...logParams ?? {} }).map(
        (it) => `${it[0]}=${JSON.stringify(replacer(it[1]))}`
      )
    );
  }, "info"),
  error: /* @__PURE__ */ __name((msg, args) => {
    console.error(
      msg,
      ...Object.entries({ ...args ?? {}, ...logParams ?? {} }).map(
        (it) => `${it[0]}=${JSON.stringify(replacer(it[1]))}`
      )
    );
  }, "error"),
  warn: /* @__PURE__ */ __name((msg, args) => {
    console.warn(
      msg,
      ...Object.entries({ ...args ?? {}, ...logParams ?? {} }).map(
        (it) => `${it[0]}=${JSON.stringify(replacer(it[1]))}`
      )
    );
  }, "warn"),
  debug: /* @__PURE__ */ __name((msg, args) => {
    console.debug(
      msg,
      ...Object.entries({ ...args ?? {}, ...logParams ?? {} }).map(
        (it) => `${it[0]}=${JSON.stringify(replacer(it[1]))}`
      )
    );
  }, "debug"),
  close: /* @__PURE__ */ __name(async () => {
  }, "close"),
  logOperation: /* @__PURE__ */ __name((operation, time, params) => {
  }, "logOperation")
}), "consoleLogger");
const noParamsLogger = consoleLogger({});
const nullPromise = Promise.resolve();
const platformNow = /* @__PURE__ */ __name(() => performance.now(), "platformNow");
const platformNowDiff = /* @__PURE__ */ __name((old) => Math.round((performance.now() - old) * 100) / 100, "platformNowDiff");
function isThenable(value) {
  return value != null && (typeof value === "object" || typeof value === "function") && typeof value.then === "function";
}
__name(isThenable, "isThenable");
const TELEMETRY_FAILURE_REPORT_INTERVAL = 3e4;
let lastTelemetryFailureReport = -Infinity;
function reportTelemetryFailure(error) {
  try {
    const now = Date.now();
    if (now >= lastTelemetryFailureReport && now - lastTelemetryFailureReport < TELEMETRY_FAILURE_REPORT_INTERVAL) {
      return;
    }
    lastTelemetryFailureReport = now;
    console.error("Failed to record telemetry", error);
  } catch {
  }
}
__name(reportTelemetryFailure, "reportTelemetryFailure");
//# sourceMappingURL=context-utils.js.map
